export const PLACEHOLDERS_RECEIVED = 'MEDIA/PLACEHOLDERS_RECEIVED';
export const PLACEHOLDER_CONSUMED = 'MEDIA/PLACEHOLDER_CONSUMED';
export const ASSIGN_PLACEHOLDERS = 'MEDIA/ASSIGN_PLACEHOLDERS';

export const MEDIA_HYDRATION_NUDGE_RECEIVED = 'MEDIA_HYDRATION_NUDGE_RECEIVED';

export const MEDIA_TYPE_PHOTO = 'photo';
export const MEDIA_TYPE_VIDEO = 'loop';
export const MEDIA_TYPE_SHORT_VIDEO = 'short_video';

export const VIDEO_TYPES = new Set([MEDIA_TYPE_VIDEO, MEDIA_TYPE_SHORT_VIDEO]);
